module.exports = __webpack_public_path__ + "static/media/custom-payment-url.6b4c87e9.svg";